import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Credentials, UserDto } from '@cradua/data';
import * as fromAuth from '../reducers';
import { LoginPageActions } from '../actions';
import { User } from '@cradua/domain';


@Component({
  selector: 'bc-login-page',
  template: `
    <bc-login-form
      (submitted)="onSubmit($event)"
      (submittedSSO)="onSubmitSSO($event)"
      (registeredsubmitted)="onRegisterSubmit($event)"
      [pending]="pending$ | async"
      [errorMessage]="error$ | async"
    >
    </bc-login-form>
  `,
  styles: [],
})
export class LoginPageComponent implements OnInit {
  pending$ = this.store.pipe(select(fromAuth.getLoginPagePending));
  error$ = this.store.pipe(select(fromAuth.getLoginPageError));
  user$ = this.store.pipe(select(fromAuth.getUser));

  constructor(private store: Store<fromAuth.State>) {}

  ngOnInit() {}

  onSubmit(credentials: Credentials) {

    //console.log("Reaching login In ", credentials);

    //return;
    this.store.dispatch(LoginPageActions.login({ credentials }));
    //this.addNewUser();
  }

  onSubmitSSO(credentials: Credentials) {

    //console.log("Reaching login In ", credentials);

    //return;
    this.store.dispatch(LoginPageActions.loginSSO({ credentials }));
    //this.addNewUser();
  }

  onRegisterSubmit(userData: UserDto) {

    let user: UserDto[] = [];
    //let userNew: UserDto = new UserDto();

    user.push(userData);
    this.store.dispatch(LoginPageActions.addUser({ user }));
    //this.addNewUser();
  }


  addNewUser() {

    let user: UserDto[] = [];
    let userNew: UserDto = new UserDto();

    userNew.Email = 'nukstel@gmail.com';
    userNew.UserName = 'nukstel@gmail.com';
    userNew.PhoneNo = '838939399394';
    userNew.password = 'Welcome';
    userNew.FirstName = 'Nuka';
    userNew.LastName = 'Adooh';
    userNew.ParentId = '5667373';

    user.push(userNew);
    this.store.dispatch(LoginPageActions.addUser({ user }));
  }


  //this.userFacade.addNewUser(newRecord);
}
